import defaultMessageTemplates from './defaultMessageTemplates'
import defaultAcceptApplicationTemplates from './defaultAcceptApplicationTemplates'

export const getDefaultMessageTemplate = (previousTemplate = null) => {
  const templates = previousTemplate ? defaultMessageTemplates.filter(template => template !== previousTemplate) : defaultMessageTemplates
  return templates[Math.floor(Math.random() * templates.length)]
}

export const getDefaultAcceptApplicationTemplate = (previousTemplate = null) => {
  const templates = previousTemplate
    ? defaultAcceptApplicationTemplates.filter(template => template !== previousTemplate)
    : defaultAcceptApplicationTemplates
  return templates[Math.floor(Math.random() * templates.length)]
}

export const templatesInitialValues = {
  message_template: getDefaultMessageTemplate(),
  accept_application_template: getDefaultAcceptApplicationTemplate(),
}

export const detailsInitialValues = {
  openings: 1,
}

export const templateVariablesBuilder = (candidateName, senderName, companyName, positionName) => [
  { token: 'candidate_first_name', value: candidateName },
  { token: 'sender_first_name', value: senderName },
  { token: 'company_name', value: companyName },
  { token: 'position_name', value: positionName },
]

export const processTemplate = (template, variables = []) => {
  if (!template) return
  if (!variables.length) return template

  return variables.reduce((processedTemplate, variable) => {
    const tokenRegex = new RegExp(`{{\\s*${variable.token}\\s*}}`, 'g')
    return processedTemplate.replace(tokenRegex, variable.value)
  }, template)
}

export const hasTemplate = template => !!(template && template.trim())

export const generateAcceptApplicationMessage = (template, candidateFirstName, senderFirstName, companyName, positionName) => {
  const templateVariables = templateVariablesBuilder(candidateFirstName, senderFirstName, companyName, positionName)
  return processTemplate(template, templateVariables)
}

const positionsDataCamelToSnakeCase = key => {
  const result = key.replace(/([A-Z])/g, ' $1')
  return result.split(' ').join('_').toLowerCase()
}

const positionsDataSnaketoCamelCase = s => {
  return s.replace(/([_][a-z])/gi, $1 => {
    return $1.toUpperCase().replace('_', '')
  })
}

const dataRemapper = (data, isTransformingToCamel) => {
  const displayAddress = isTransformingToCamel ? 'display_address' : 'displayAddress'
  const inputtedAddr = isTransformingToCamel ? 'inputted_address' : 'inputtedAddress'
  const transformer = isTransformingToCamel ? positionsDataSnaketoCamelCase : positionsDataCamelToSnakeCase
  return data.map(location => {
    return Object.keys(location).reduce(
      (accumulator, current) => ({
        ...accumulator,
        [transformer(current)]: location[current],
        type: isTransformingToCamel ? location.type.toUpperCase() : location.type.toLowerCase(),
        value: location[inputtedAddr],
        label: location[displayAddress],
      }),
      {},
    )
  })
}

export const transformPositionsList = (data = [], transformer = 'camel') => {
  const isTransformingToCamel = transformer === 'camel'
  let transformed = []
  if (data && data.length > 0) {
    transformed = dataRemapper(data, isTransformingToCamel)
  }
  return transformed
}

export const isAtsConnectionKnown = atsConnected => typeof atsConnected === 'boolean'

const PublishedStatus = {
  Published: 'PUBLISHED',
  Unpublished: 'UNPUBLISHED',
}

Object.freeze(PublishedStatus)

export { PublishedStatus }

const AtsJobStatus = {
  Open: 'OPEN',
  Closed: 'CLOSED',
  Draft: 'DRAFT',
  Archived: 'ARCHIVED',
  Pending: 'PENDING',
}

Object.freeze(AtsJobStatus)

export { AtsJobStatus }

const AtsJobStatusMap = {
  [AtsJobStatus.Closed]: 'closed',
  [AtsJobStatus.Archived]: 'archived',
  [AtsJobStatus.Draft]: 'unavailable',
  [AtsJobStatus.Pending]: 'unavailable',
}

Object.freeze(AtsJobStatusMap)

export { AtsJobStatusMap }

const CreatePositionMechanism = {
  Manual: 'manual',
  Prompt: 'prompt',
  PDF: 'PDF',
  URL: 'URL',
  Search: 'search',
}

Object.freeze(CreatePositionMechanism)

export { CreatePositionMechanism }
